<template lang="pug">
div.dashboard-find
  h2 {{$options.filters.translate('CSV Report - choose criteria', lang)}}
    small.text-muted &nbsp;({{$options.filters.translate('Limit of states', lang)}})
  form.form-inline
    .form-group
      label.label {{$options.filters.translate('Network', lang)}}
        sup *
      select.perPage.form-control(v-model='network')
        option(selected value='0') {{$options.filters.translate('Select', lang)}}
        option(v-for='(network, index) in userNetworks', :value='network.id') {{network.name}}
    .form-group
      label.label {{$options.filters.translate('Date from', lang)}}
        sup *
      date-picker(v-model='dateFrom' :config='pickerConfig')
    .form-group
      label.label {{$options.filters.translate('Date to', lang)}}
        sup *
      date-picker(v-model='dateTo' :config='pickerConfig2')
    button.btn.btn-default(@click.prevent='getData()') {{$options.filters.translate('Save', lang)}} Status & failures
    button.btn.btn-default(@click.prevent='getDataDowntime()') {{$options.filters.translate('Save', lang)}} Downtimes
    br
    .small * {{$options.filters.translate('required', lang)}}
    .small ** {{$options.filters.translate('Duration in seconds', lang)}}

</template>
<script lang="js">
export default {
  props: ['lang'],
  data () {
    return {
      pickerConfig: {format: 'YYYY-MM-DD HH:mm', maxDate: this.$moment().format('YYYY-MM-DD HH:mm'), minDate: false, icons: {time: 'fa fa-lg fa-clock'}},
      pickerConfig2: {format: 'YYYY-MM-DD HH:mm', maxDate: this.$moment().format('YYYY-MM-DD HH:mm'), minDate: false, icons: {time: 'fa fa-lg fa-clock'}},
      network: 0,
      dateFrom: this.$moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm'),
      dateTo: this.$moment().format('YYYY-MM-DD HH:mm')
    }
  },
  computed: {
    console: () => console,
    userNetworks () {
      return this.$store.getters.networks.filter((n) => this.$store.getters.user.networks.includes(n.id))
    }
  },
  methods: {
    getData () {
      if (this.network === 0) {
        return this.$notify(this.$options.filters.translate('Please select Network', this.lang), 'error')
      }
      if (!this.dateFrom || !this.dateTo) {
        return this.$notify(this.$options.filters.translate('Please select dates', this.lang), 'error')
      }
      this.$http.post('dashboard/csv', { network: this.network, dateFrom: this.$moment(this.dateFrom).valueOf(), dateTo: this.$moment(this.dateTo).valueOf() })
        .then(response => {
          const blob = new Blob([response.data], { type: 'text/csv' })
          const url = window.URL.createObjectURL(blob)

          window.open(url)
        })
    },
    getDataDowntime () {
      if (this.network === 0) {
        return this.$notify(this.$options.filters.translate('Please select Network', this.lang), 'error')
      }
      if (!this.dateFrom || !this.dateTo) {
        return this.$notify(this.$options.filters.translate('Please select dates', this.lang), 'error')
      }
      this.$http.post('dashboard/csvDowntimes', { network: this.network, dateFrom: this.$moment(this.dateFrom).valueOf(), dateTo: this.$moment(this.dateTo).valueOf() })
        .then(response => {
          const blob = new Blob([response.data], { type: 'text/csv' })
          const url = window.URL.createObjectURL(blob)

          window.open(url)
        })
    }
  }
}
</script>
<style lang="sass">
.dashboard-find
  .label
    margin-left: 8px
    margin-right: 4px
    font-size: 100%
  .btn
    margin-left: 8px
  table
    margin-top: 8px
    td
      cursor: pointer
  .downtime
    float: left
</style>



// WEBPACK FOOTER //
// src/components/dashboard/csv.vue